// import "./style.scss";
// import "./scss/themes/themes.scss";
// import "./scss/themes/common.scss";
// import "./index.js";

import { findParentUntilMultipleChildren, isImageSource, restoreOriginalImageSrc } from "../utils";
import getClickAbleDom from "../utils/getClickAbleDom";



// Full Screen
document.addEventListener("DOMContentLoaded", function () {
  const modelWrapper = document.querySelectorAll(".modelViewerBlock");

  setTimeout(() => {
    Object.values(modelWrapper).map((wrapper) => {
      const models = wrapper.querySelectorAll("model-viewer") || wrapper.querySelectorAll(".online_3d_viewer");
      const progressElement = wrapper.querySelector(".progress");

      models.forEach((model) => {
        const src = new URL(model?.src || model?.getAttribute("src") || model?.getAttribute("model"));
        if (model.tagName === "DIV") {
          console.log("Advanced viewer");
        } else {
          // add/remove ssl from url depends on website
          if (src?.protocol !== location?.protocol) {
            model?.setAttribute("src", src.href.replace(src?.protocol, location?.protocol));
          }

          if (progressElement) {
            model?.addEventListener("progress", (e) => {
              progressElement.innerHTML = parseInt(e.detail.totalProgress * 100) + "%";
            });
            model?.addEventListener("load", () => {
              setTimeout(() => {
                progressElement.style.display = "none";
              }, 500);
            });
          }

          model.dataset.items = "";

          // set model width for goya theme
          const productModalContainer = document.querySelector(".product-modal-wrap");
          if (
            productModalContainer &&
            !productModalContainer?.nextElementSibling?.classList?.contains("entry-summary") &&
            !productModalContainer?.nextElementSibling?.classList?.contains("mkd-single-product-summary")
          ) {
            // productModalContainer.style.width = "100%";
            productModalContainer.classList.add("model-full-width");
            const information = document.querySelector(".showcase-inner .product-information");
            if (information) {
              const model = productModalContainer.querySelector("model-viewer");
              if (model) {
                model.style.height = information.offsetHeight + "px";
              }
            }
          }
        }
      });
    });
  }, 1000);

  document.querySelectorAll(".bp3dv-model-main")?.forEach((model) => {
    let selector = model.dataset.selector;

    if (!selector || selector === "") {
      return false;
    }

    let clickableItem = getClickAbleDom(selector)

    if (clickableItem) {
      clickableItem?.addEventListener("click", (e) => {
        e.preventDefault();
        model.classList.add("model-open");
        window.dispatchEvent(new Event('resize'))
      });

      clickableItem.style.cursor = "pointer";

      model.querySelector(".close-btn").addEventListener("click", () => model.classList.remove("model-open"));
      model.querySelector(".bg-overlay").addEventListener("click", () => model.classList.remove("model-open"));
    } else {
      console.warn("clickable item is not found", selector);
    }
  });
});



if (window.jQuery) {
  jQuery(document).ready(function ($) {
    $(".bp3dmodel-carousel")?.[0]?.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
    });
  });
}
